import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    description: 'Header in modal to deactivate marketplace.',
    defaultMessage: 'Deactivate {storeName}',
    id: 'd12XOQ',
  },
  deactivateMarketplaceBody: {
    description: 'Message asking the user if they are sure they want to deactivate the marketplace.',
    defaultMessage: 'Are you sure you want to deactivate this connection? Before you do, please:',
    id: 'mD3rFa',
  },
  deactivateMarketplaceBodyStep1: {
    description:
      'First step that is recommended before deactivating a marketplace. Let the marketplace know you are not accepting new orders.',
    defaultMessage: '1. Notify <b>{storeName}</b> that you are not accepting new orders.',
    id: 'BSbmoK',
  },
  deactivateMarketplaceBodyStep2: {
    description:
      'Second step that is recommended before deactivating a marketplace. Resolve any outstanding orders currently awaiting shipment.',
    defaultMessage:
      '2. Resolve any outstanding orders currently awaiting shipment. Shipping them after deactivating the connection will prevent tracking information from being shared with <b>{storeName}</b>.',
    id: 'DZMf0h',
  },
  deactivateMarketplaceButton: {
    description: 'button to deactivate marketplace',
    defaultMessage: 'Deactivate Marketplace',
    id: '62IOp9',
  },
  deactivatingMarketplaceTitle: {
    description: 'Title informing the user the deactivation request is being processed',
    defaultMessage: 'Deactivating Marketplace',
    id: 'Wj56ji',
  },
  deactivatingMarketplaceMessage: {
    description: 'Message indicating the deactivation is being processed',
    defaultMessage: 'Deactivating {storeName}. Please wait...',
    id: 'HzLLR+',
  },
  succesfulDeactivationTitle: {
    description: 'Title informing the user the deactivation was processed successfully',
    defaultMessage: 'Successful deactivation',
    id: 'qLUdI6',
  },
  succesfulDeactivationMessage: {
    description: 'Message indicating the deactivation was processed successfully',
    defaultMessage: '{storeName} has been successfully deactivated.',
    id: 'NRQ59W',
  },
  failedDeactivationTitle: {
    description: 'Title for message informing user that deactivation request failed',
    defaultMessage: 'Marketplace Deactivation Error',
    id: 'OqISu4',
  },
  failedDeactivationMessage: {
    description: 'message informing user that deactivation request failed',
    defaultMessage: 'System error on our side. Please try again.',
    id: 'kLlcgx',
  },
});

export default messages;
